export function useInitialDataLoad() {
  const auth = useAuth()
  const loginRedirect = useLoginRedirect()
  const userInfoStore = useUserInfoStore()
  const brandsStore = useBrandsStore()
  const brandSwitchAnimationStore = useBrandSwitchAnimationStore()
  const seasonStore = useSeasonsStore()

  async function initialDataLoad() {
    const perf = createPerfTimer('initialDataLoad')
    await Promise.allSettled([loadUserInfo(), loadBrands(), loadSeasons()])
    perf.end()

    const { setUser } = useSentry()
    const { userInfo } = useUserInfoStore()
    setUser({ id: userInfo.id ?? 'not', email: userInfo.email ?? 'unknown' })

    // NOTE: this is done so the brand switch animation isn't triggered on page refresh/load
    brandSwitchAnimationStore.markInitialDataLoaded()
  }

  async function loadUserInfo() {
    const result = await userInfoStore.loadFrontendUser()
    if (isErr(result)) {
      throw routeErrorFromGQL(result)
    }
  }

  async function loadBrands() {
    const result = await brandsStore.loadBrands()
    if (isErr(result)) {
      throw routeErrorFromGQL(result)
    }

    // If no brands are available, log out the user
    if (!brandsStore.hasBrands) {
      await auth.logout()
    }
  }

  async function loadSeasons() {
    const result = await seasonStore.loadSeasons()
    if (isErr(result)) {
      throw routeErrorFromGQL(result)
    }
  }

  async function afterSuccessfulLogin(redirectTo?: string) {
    await initialDataLoad()
    await loginRedirect.navigateToRedirect(redirectTo)
  }

  return { initialDataLoad, afterSuccessfulLogin }
}
